import { render } from "./TipTapMenuItem.vue?vue&type=template&id=dc2c13d6"
import script from "./TipTapMenuItem.vue?vue&type=script&lang=js"
export * from "./TipTapMenuItem.vue?vue&type=script&lang=js"

import "./TipTapMenuItem.vue?vue&type=style&index=0&id=dc2c13d6&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__